module.exports = __webpack_public_path__ + "img/leval-8.2eca515a.png";